import { ArrowRight } from "../../assets/images";
const productsResidenciaUnifamiliar = [
  {
    id: 0,
    name: "Sair",
    environmentArea: 0,
    category: { image: ArrowRight },
    pinPos: [753.6705505013035, 179.4331464232611, -564.0816180280942],
    scale: 0.7,
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 522.0997932360405,
        y: 234.3866482659554,
        z: -587.3078398946157,
      },
      target: {
        x: 521.5026932288724,
        y: 234.08996335939108,
        z: -586.5625549506802,
      },
      posMobile: {
        x: 522.0997932360405,
        y: 234.3866482659554,
        z: -587.3078398946157,
      },
      targetMobile: {
        x: 521.5026932288724,
        y: 234.08996335939108,
        z: -586.5625549506802,
      },
    },
    cameraOut: {
      pos: {
        x: 521.6648688851656,
        y: 234.27315643194626,
        z: -587.5321627861857,
      },
      target: {
        x: 521.5026932288724,
        y: 234.08996335939108,
        z: -586.5625549506802,
      },
    },
  },
  {
    id: -1,
    name: "Entrar",
    environmentArea: 0,
    category: { image: ArrowRight },
    pinPos: [507.506079640183, 163.87407055940196, -1000.5287797419821],
    scale: 1,
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 804.968183077821,
        y: 220.65497811340387,
        z: -788.6655126395825,
      },
      target: {
        x: 805.504471746988,
        y: 220.49317855486163,
        z: -787.8371314675496,
      },
      posMobile: {
        x: 804.968183077821,
        y: 220.65497811340387,
        z: -788.6655126395825,
      },
      targetMobile: {
        x: 805.504471746988,
        y: 220.49317855486163,
        z: -787.8371314675496,
      },
    },
    cameraOut: {
      pos: {
        x: 804.9911872400249,
        y: 220.89568596260477,
        z: -788.5863749653479,
      },
      target: {
        x: 805.4099020979849,
        y: 220.4977061432917,
        z: -787.7701091194722,
      },
    },
  },
  {
    id: 13,
    environmentArea: 0,
    pinPos: [489.7067839292081, 225.22920864078384, 511.2423270555407],
    scale: 1.3,
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 251.71644792222324,
        y: 138.55844373063894,
        z: 247.83874529405358,
      },
      target: {
        x: 252.48640480326205,
        y: 138.79661831657756,
        z: 248.43072440513265,
      },
      posMobile: {
        x: 251.71644792222324,
        y: 138.55844373063894,
        z: 247.83874529405358,
      },
      targetMobile: {
        x: 252.48640480326205,
        y: 138.79661831657756,
        z: 24,
      },
    },
    cameraOut: {
      pos: {
        x: 521.6648688851656,
        y: 234.27315643194626,
        z: -587.5321627861857,
      },
      target: {
        x: 521.5026932288724,
        y: 234.08996335939108,
        z: -586.5625549506802,
      },
    },
  },
  {
    id: 14,
    environmentArea: 0,
    pinPos: [365.16295382425415, 347.13015952399553, 494.0770079794687],
    scale: 1.3,
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 252.054531610648,
        y: 138.18518050007708,
        z: 247.70289344814253,
      },
      target: {
        x: 252.51763566452246,
        y: 138.80768119033695,
        z: 248.33378767533998,
      },
      posMobile: {
        x: 252.054531610648,
        y: 138.18518050007708,
        z: 247.70289344814253,
      },
      targetMobile: {
        x: 252.51763566452246,
        y: 138.80768119033695,
        z: 248.33378767533998,
      },
    },
    cameraOut: {
      pos: {
        x: 521.6648688851656,
        y: 234.27315643194626,
        z: -587.5321627861857,
      },
      target: {
        x: 521.5026932288724,
        y: 234.08996335939108,
        z: -586.5625549506802,
      },
    },
  },
  {
    id: 15,
    pinPos: [1767.827570645733, 252.3126373063985, 302.2229171141928],
    scale: 1.6,
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 1452.4139080296368,
        y: 157.6158101688306,
        z: -235.17119060122008,
      },
      target: {
        x: 1453.055809449527,
        y: 157.73575128875464,
        z: -234.41384213789925,
      },
      posMobile: {
        x: 1452.4139080296368,
        y: 157.6158101688306,
        z: -235.17119060122008,
      },
      targetMobile: {
        x: 1453.055809449527,
        y: 157.73575128875464,
        z: -234.41384213789925,
      },
    },
    cameraOut: {
      pos: {
        x: 804.9911872400249,
        y: 220.89568596260477,
        z: -788.5863749653479,
      },
      target: {
        x: 805.4099020979849,
        y: 220.4977061432917,
        z: -787.7701091194722,
      },
    },
  },
  {
    id: 16,
    environmentArea: 0,
    pinPos: [191.28859355518853, 421.37594650531275, 543.2060169748049],
    scale: 1.3,
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 252.5514375937491,
        y: 138.16239213535724,
        z: 247.4824106086296,
      },
      target: {
        x: 252.54886290010393,
        y: 138.81874277977604,
        z: 248.23686219920626,
      },
      posMobile: {
        x: 252.5514375937491,
        y: 138.16239213535724,
        z: 247.4824106086296,
      },
      targetMobile: {
        x: 252.54886290010393,
        y: 138.81874277977604,
        z: 248.23686219920626,
      },
    },
    cameraOut: {
      pos: {
        x: 521.6648688851656,
        y: 234.27315643194626,
        z: -587.5321627861857,
      },
      target: {
        x: 521.5026932288724,
        y: 234.08996335939108,
        z: -586.5625549506802,
      },
    },
  },
  {
    id: 17,
    pinPos: [1036.6151439275345, 27.727772647850216, -715.8254161025947],
    scale: 1,
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 840.6908759367673,
        y: 287.3657026582148,
        z: -997.141535007173,
      },
      target: {
        x: 841.2821841148346,
        y: 286.7719877880945,
        z: -996.5957719710954,
      },
      posMobile: {
        x: 840.6908759367673,
        y: 287.3657026582148,
        z: -997.141535007173,
      },
      targetMobile: {
        x: 841.2821841148346,
        y: 286.7719877880945,
        z: -996.5957719710954,
      },
    },
    cameraOut: {
      pos: {
        x: 804.9911872400249,
        y: 220.89568596260477,
        z: -788.5863749653479,
      },
      target: {
        x: 805.4099020979849,
        y: 220.4977061432917,
        z: -787.7701091194722,
      },
    },
  },
  {
    id: 18,
    environmentArea: 0,
    pinPos: [679.8516791976903, 208.4315673156712, -210.78533454178444],
    scale: 1,
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 403.4750501058516,
        y: 137.7908251223396,
        z: -187.76614832168542,
      },
      target: {
        x: 404.40923985440367,
        y: 138.05764602825997,
        z: -188.0029945119949,
      },
      posMobile: {
        x: 403.4750501058516,
        y: 137.7908251223396,
        z: -187.76614832168542,
      },
      targetMobile: {
        x: 404.40923985440367,
        y: 138.05764602825997,
        z: -188.0029945119949,
      },
    },
    cameraOut: {
      pos: {
        x: 521.6648688851656,
        y: 234.27315643194626,
        z: -587.5321627861857,
      },
      target: {
        x: 521.5026932288724,
        y: 234.08996335939108,
        z: -586.5625549506802,
      },
    },
  },
  {
    id: 19,
    pinPos: [215.88332267389876, -80.83480205952694, -47.16630195524556],
    scale: 1,
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: -109.82919837157387,
        y: -87.91208377310258,
        z: -244.24328161504428,
      },
      target: {
        x: -108.90002256082145,
        y: -87.89102383617751,
        z: -243.87424395874172,
      },
      posMobile: {
        x: -109.82919837157387,
        y: -87.91208377310258,
        z: -244.24328161504428,
      },
      targetMobile: {
        x: -108.90002256082145,
        y: -87.89102383617751,
        z: -243.87424395874172,
      },
    },
    cameraOut: {
      pos: {
        x: 521.6648688851656,
        y: 234.27315643194626,
        z: -587.5321627861857,
      },
      target: {
        x: 521.5026932288724,
        y: 234.08996335939108,
        z: -586.5625549506802,
      },
    },
  },

  {
    id: 60,
    pinPos: [442.0899016056302, 28.81454004200866, -1041.721991562936],
    scale: 1,
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 587.7631323456415,
        y: 114.31874696397895,
        z: -813.391072122335,
      },
      target: {
        x: 587.1179695691081,
        y: 114.03921041700147,
        z: -814.1021447702971,
      },
      posMobile: {
        x: 587.7631323456415,
        y: 114.31874696397895,
        z: -813.391072122335,
      },
      targetMobile: {
        x: 587.1179695691081,
        y: 114.03921041700147,
        z: -814.1021447702971,
      },
    },
    cameraOut: {
      pos: {
        x: 521.3717611893915,
        y: 234.28909705192766,
        z: -585.5913687823612,
      },
      target: {
        x: 521.5026932288724,
        y: 234.08996335939108,
        z: -586.5625549506802,
      },
    },
  },
];

export default productsResidenciaUnifamiliar;
